'use strict';

DoohApps
.directive('versionfileread', ['DialogHandler', 'UploadFileStorage', function (DialogHandler, UploadFileStorage) {
    return {
        restrict: 'EA',
        scope: {
            object: '=object'
        },
        link: function (scope, element) {
            element.bind('change', function (changeEvent) {
                scope.object.HasFile = false;

                if (changeEvent.target.files.length > 0)
                    UploadFileStorage.SetFiles(changeEvent.target.files);

                if (UploadFileStorage.HasFiles()) {
                    scope.object.HasFile = true;
                    var files = UploadFileStorage.GetFiles();

                    scope.object.Files = [];
                    for (var i = 0; i < files.length; i++) {

                        scope.$apply(function () {
                            var obj = {};

                            obj.FileID = 0;
                            obj.HasFile = true;
                            obj.FileName = files[i].name;
                            obj.VirtualPath = '';
                            obj.uploadLinkRecieved = true;
                            obj.uploadRecieved = true;
                            obj.Error = '';

                            scope.object.Files.push(obj);

                        });
                    }
                }
            });
        }
    }
}]);